<template>
  <div class="project">
    <textarea v-model.trim="value" placeholder="请输入课程代码"></textarea>
    <p>课程代码请在课程详情中查看</p>
    <div v-show="error" class="error">
      <img src="@/assets/image/user/content_icon_error2x.png" alt="" />
      <span>课程不存在</span>
    </div>
    <van-button class="save-btn" @click="save" round size="large" type="info">提交</van-button>
    <!-- <Back /> -->
  </div>
</template>

<script>
import {getLessonByCode} from '@/api'
export default {
  data() {
    return {
      value: '',
      error: false
    }
  },
  methods: {
    save() {
      if (!this.value) {
        this.$Toast.fail('课程代码不能为空')
        return false
      }
      getLessonByCode({code: this.value}).then(res => {
        if (res.code === 0) {
          if (res.data > 0) {
            this.error = false
            this.$router.push(`/projectDetail/${this.value}`)
          } else {
            this.error = true
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.project {
  padding: 12px 16px;
  textarea {
    resize: none;
    width: 100%;
    border: none;
    border-radius: 8px;
    padding: 10px;
    height: 100px;
    background: #ffffff;
    box-shadow: 0px 0px 12px 0px rgba(23, 38, 71, 0.08);
  }
  p {
    font-size: 14px;
    font-weight: 500;
    text-align: left;
    color: #c0c4cc;
  }
  .save-btn {
    margin-top: 40px;
  }
  div.error {
    img {
      width: 15px;
      height: 15px;
      vertical-align: middle;
    }
    span {
      color: rgba(209, 62, 23, 1);
      font-weight: 500;
      font-size: 14px;
      vertical-align: middle;
      padding-left: 4px;
    }
  }
}
</style>
